import { ModuleWithProviders, NgModule } from '@angular/core';
import { defaultStripeOptions, defaultStripeStyles, STRIPE_PUBLISHABLE_KEY, US_STRIPE_PUBLISHABLE_KEY, STRIPE_OPTIONS, STRIPE_STYLE_OPTIONS } from './stripe.types';
import { AzcStripeCardComponent } from './card/stripe-card.component';
import { CommonModule } from '@angular/common';
import { StripeService, USStripeService } from './stripe.service';
import { AzcStripePaymentRequestComponent } from './payment-request/stripe-payment-request.component';

@NgModule({
	imports: [CommonModule],
	declarations: [AzcStripeCardComponent, AzcStripePaymentRequestComponent],
	exports: [AzcStripeCardComponent, AzcStripePaymentRequestComponent],
})

export class AzcStripeModule {
	public static forRoot(
		publishableKey: () => Promise<string>,
		usPublishableKey: () => Promise<string>,
		options: stripe.elements.ElementsCreateOptions = defaultStripeOptions
	): ModuleWithProviders {
		return {
			ngModule: AzcStripeModule,
			providers: [
				StripeService,
				USStripeService,
				{
					provide: STRIPE_PUBLISHABLE_KEY,
					useFactory: publishableKey
				},
				{
					provide: US_STRIPE_PUBLISHABLE_KEY,
					useFactory: usPublishableKey
				},
				{
					provide: STRIPE_OPTIONS,
					useValue: options
				},
				{
					provide: STRIPE_STYLE_OPTIONS,
					useValue: defaultStripeStyles
				}
			]
		};
	}
}
